import { memo } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { useSelector } from '@bonanza-social/toolkit/state';
import { formatNumber } from '@bonanza-social/toolkit/utils';
import { Box, Text } from '@bonanza-social/moonlight';
import {
  selectPrizeWallPrizes,
  selectPrizeWallWinProbability,
} from '../../../state/prizeWall/prizeWall.slice';
import { PrizeWallInfoPrizesProps } from './PrizeWallInfoPrizes.types';
import PrizeWallInfoPrizesSkeleton from './PrizeWallInfoPrizesSkeleton/PrizeWallInfoPrizesSkeleton';

function PrizeWallInfoPrizes(props: PrizeWallInfoPrizesProps) {
  const [t] = useTranslation('prizeWall');
  const prizes = useSelector(selectPrizeWallPrizes);
  const winProbability = useSelector(selectPrizeWallWinProbability);

  return (
    <Box gap="space-200" {...props}>
      <Text variant="body-m" color="darkSurfacePrimary">
        {t('prizeWallInfoOdds')}
      </Text>
      <Text variant="body-m" color="darkSurfacePrimary">
        {t('prizeWallInfoSpinChance', { percent: winProbability })}
      </Text>
      <Box
        borderRadius="radius-200"
        backgroundColor={prizes ? 'primaryBackground' : undefined}
        marginTop="space-600"
      >
        {prizes ? (
          prizes.ids.map((prizeId, index) => (
            <Box
              key={prizeId}
              flexDirection="row"
              justifyContent="space-between"
              borderTopWidth={index > 0 ? 'border-width-025' : 'border-width-0'}
              borderColor="borderSecondary"
              padding="space-300"
            >
              <Text variant="body-s-semi" color="darkSurfacePrimary">
                {prizes.byId[prizeId].name}
              </Text>
              <Text variant="caption" color="darkSurfaceSecondary">
                {t('prizeWallPrizeQuantity', {
                  totalQuantity: formatNumber(
                    prizes.byId[prizeId].totalQuantity,
                  ),
                  context: 'multiplier',
                })}
              </Text>
            </Box>
          ))
        ) : (
          <PrizeWallInfoPrizesSkeleton />
        )}
      </Box>
    </Box>
  );
}

export default memo(PrizeWallInfoPrizes);
